import { Button, Popover } from "@snpjs/core";

import { IInstallGuideMenuProps } from "./installGuideMenu/IInstallGuideMenuProps";
import { InstallGuideMenu } from "./installGuideMenu/InstallGuideMenu";
import { texts } from "../../i18n/texts";
import useTranslation from "../../hooks/useTranslation";

/**
 * Intall Guide Button.
 */
export const InstallGuideButton: React.FC<IInstallGuideMenuProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Popover
        content={
          <InstallGuideMenu
            objectId={props.objectId}
            checksumSha1={props.checksumSha1}
          />
        }
        placement="bottom-start"
      >
        <Button
          text={t(texts.installChecklist.furtherOptions)}
          icon="list"
          rightIcon="caret-down"
          minimal={true}
        />
      </Popover>
    </>
  );
};
